module.exports = __webpack_public_path__ + "static/media/bz.e559a5b4.svg";